<template>
  <div class="keshi">
    <!-- 智透 -->
    <div class="zhitou">
      <div class="title">
        <titleCard title="智透-血透管理平台"></titleCard>
      </div>
      <div class="content">
        <div class="left animate__animated wow animate__fadeInLeft" data-wow-duration="1.2s">
          严格按照透析室工作流程合理设计，全面提升医院的综合管理能力与临床科研水准，助力患者透析全过程管理。</div>
        <div class="right animate__animated wow animate__fadeInRight" data-wow-duration="1s">
          <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/9AC5537F9D6A428C92D4BD62E8712D63-6-2.png" alt="">
        </div>
      </div>
      <div class="title2">
        <titleCard title="全流程信息化管理体系与解决方案"></titleCard>
      </div>
    </div>
    <!-- 全流程信息化管理体系与解决方案 -->
    <div class="xinxi">
      <div class="header">
        <div class="header-title">系统功能</div>
        <div class="header-content animate__animated wow animate__fadeInUp">
          <ul class="left">
            <li v-for="item in leftList" :key="item.id" @click="clickChange(item)" :id="item.id === glID?'liClick':''">
              {{item.title}}</li>
          </ul>
          <div class="in">
            <div class="pic"><img :src="inList.pic"></div>
            <ul class="txt">
              <li v-for="(item,index) in inList.txt" :key="index">{{item}}</li>
            </ul>
          </div>
          <ul class="right">
            <li v-for="item in rightList" :key="item.id" @click="clickChange(item)"
              :id="item.id === glID?'liClick2':''">
              {{item.title}}</li>
          </ul>
        </div>
        <div class="ios-content">
          <ul class="contentmenu">
            <li v-for="item in IosList" :key="item.id" @click="clickChange(item)" :id="item.id === glID?'liClick':''">
              {{item.title}}</li>
          </ul>
          <div class="in">
            <div class="pic"><img :src="inList.pic"></div>
            <ul class="txt">
              <li v-for="(item,index) in inList.txt" :key="index">{{item}}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="titletxt">管理流程</div>
        <div class="pc-content">
          <div class="content">
            <div class="box animate__animated wow animate__fadeIn" data-wow-duration="1s">
              <div class="left"><img src="../../assets/image/News/keshi/icon1.webp" alt=""></div>
              <div class="right">
                <h2>透前准备</h2>
                <p>患者建档 预约排班<br>患者状态 透析方式</p>
              </div>
            </div>
            <div class="arrow"><img src="../../assets/image/News/keshi/right.webp" alt=""></div>
            <div class="box animate__animated wow animate__fadeIn" data-wow-duration="2s">
              <div class="left"><img src="../../assets/image/News/keshi/icon2.webp" alt=""></div>
              <div class="right">
                <h2>快速接诊</h2>
                <p>排班展示 自动称量<br> 方案制订 快捷绑定<br>标签识别</p>
              </div>
            </div>
            <div class="arrow"><img src="../../assets/image/News/keshi/right.webp" alt=""></div>
            <div class="box animate__animated wow animate__fadeIn" data-wow-duration="3s">
              <div class="left"><img src="../../assets/image/News/keshi/icon3.webp" alt=""></div>
              <div class="right">
                <h2>透析治疗</h2>
                <p>制定医嘱 医嘱推送<br> 透析监测 使用耗材<br> 透析机联机</p>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="arrow"><img src="../../assets/image/News/keshi/bottom.webp" alt=""></div>
          </div>
          <div class="content">
            <div class="box animate__animated wow animate__fadeIn" data-wow-duration="4s">
              <div class="left"><img src="../../assets/image/News/keshi/icon4.webp" alt=""></div>
              <div class="right">
                <h2>日常管理</h2>
                <p>库存管理 设备管理<br>历史数据 医疗文书</p>
              </div>
            </div>
            <div class="arrow"><img src="../../assets/image/News/keshi/left.webp" alt=""></div>
            <div class="box animate__animated wow animate__fadeIn" data-wow-duration="5s">
              <div class="left"><img src="../../assets/image/News/keshi/icon5.webp" alt=""></div>
              <div class="right">
                <h2>统计分析</h2>
                <p>耗材统计 费用统计<br> 透析记录 生成医嘱单</p>
              </div>
            </div>
            <div class="arrow"><img src="../../assets/image/News/keshi/left.webp" alt=""></div>
            <div class="box animate__animated wow animate__fadeIn" data-wow-duration="6s">
              <div class="left"><img src="../../assets/image/News/keshi/icon6.webp" alt=""></div>
              <div class="right">
                <h2>透后评估</h2>
                <p>患者宣教 自助称重<br> 指标评估 质控消毒</p>
              </div>
            </div>
          </div>
        </div>
        <div class="ios-content">
          <div class="content">
            <div class="box animate__animated wow animate__fadeIn">
              <div class="left"><img src="../../assets/image/News/keshi/icon1.webp" alt=""></div>
              <div class="right">
                <h2>透前准备</h2>
                <p>患者建档 预约排班<br>患者状态 透析方式</p>
              </div>
            </div>
            <div class="arrow"><img src="../../assets/image/News/keshi/right.webp" alt=""></div>
            <div class="box animate__animated wow animate__fadeIn">
              <div class="left"><img src="../../assets/image/News/keshi/icon2.webp" alt=""></div>
              <div class="right">
                <h2>快速接诊</h2>
                <p>排班展示 自动称量<br> 方案制订 快捷绑定<br>标签识别</p>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="arrow"><img src="../../assets/image/News/keshi/bottom.webp" alt=""></div>
          </div>
          <div class="content">
            <div class="box animate__animated wow animate__fadeIn">
              <div class="left"><img src="../../assets/image/News/keshi/icon6.webp" alt=""></div>
              <div class="right">
                <h2>透后评估</h2>
                <p>患者宣教 自助称重<br> 指标评估 质控消毒</p>
              </div>
            </div>
            <div class="arrow"><img src="../../assets/image/News/keshi/left.webp" alt=""></div>
            <div class="box animate__animated wow animate__fadeIn">
              <div class="left"><img src="../../assets/image/News/keshi/icon3.webp" alt=""></div>
              <div class="right">
                <h2>透析治疗</h2>
                <p>制定医嘱 医嘱推送<br> 透析监测 使用耗材<br> 透析机联机</p>
              </div>
            </div>

          </div>
          <div class="bottom">
            <div class="arrow2"><img src="../../assets/image/News/keshi/bottom.webp" alt=""></div>
          </div>
          <div class="content">
            <div class="box animate__animated wow animate__fadeIn">
              <div class="left"><img src="../../assets/image/News/keshi/icon5.webp" alt=""></div>
              <div class="right">
                <h2>统计分析</h2>
                <p>耗材统计 费用统计<br> 透析记录 生成医嘱单</p>
              </div>
            </div>
            <div class="arrow"><img src="../../assets/image/News/keshi/right.webp" alt=""></div>
            <div class="box animate__animated wow animate__fadeIn">
              <div class="left"><img src="../../assets/image/News/keshi/icon4.webp" alt=""></div>
              <div class="right">
                <h2>日常管理</h2>
                <p>库存管理 设备管理<br>历史数据 医疗文书</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="box animate__animated wow animate__fadeInUp" data-wow-duration="1s">
          <div class="pic"><img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/AF647434187B484CA11BB895F48D9613-6-2.png" alt="">
            <div class="bg">数据实时同步化、智能化自动排班 丰富的统计报表、规范化工作流程 医疗信息可共享</div>
          </div>
          <div class="txt">Web、平板多端管理</div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp" data-wow-duration="1.4s">
          <div class="pic"><img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/9AD0D320264D4C3FB450D14C43F9DAB2-6-2.png" alt="">
            <div class="bg">患者快速上机，透析方案制定，特色医疗标签，床旁医嘱执行，透析指标评估，数据快捷查询</div>
          </div>
          <div class="txt">移动医护工作站</div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp" data-wow-duration="1.8s">
          <div class="pic"><img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/3393953D01214D8992A887350753D7FB-6-2.png" alt="">
            <div class="bg">“软硬兼施”患者自助系统，血透物联网，数据采集自动化，简化繁杂工作，解放劳动力</div>
          </div>
          <div class="txt">患者数据自动化采集</div>
        </div>
      </div>
    </div>
    <footerCard name="林老师" phone="135-2227-8747"></footerCard>
  </div>
</template>

<script>
import footerCard from '../../components/footer-card2.vue'
import titleCard from '../../components/title-card.vue'
export default {
  data() {
    return {
      //  移动端导航
      IosList: [
        {
          id: 1,
          title: '患者管理',
          name: 'huanzhe'
        },
        {
          id: 2,
          title: '药品管理',
          name: 'yaopin'
        }, {
          id: 3,
          title: '耗材管理',
          name: 'haocai'
        }, {
          id: 4,
          title: '透析管理',
          name: 'touxi'
        }, {
          id: 5,
          title: '医嘱管理',
          name: 'yizhu'
        }, {
          id: 6,
          title: '人员管理',
          name: 'renyuan'
        }, {
          id: 7,
          title: '设备管理',
          name: 'shebei'
        },
        {
          id: 8,
          title: '字典管理',
          name: 'zidian'
        },
        {
          id: 9,
          title: '系统管理',
          name: 'xitong'
        }, {
          id: 10,
          title: '历史数据',
          name: 'lishi'
        }, {
          id: 11,
          title: '医疗文书',
          name: 'yiliao'
        }, {
          id: 12,
          title: '统计分析',
          name: 'tongji'
        }, {
          id: 13,
          title: '质控上报',
          name: 'zhikong'
        }, {
          id: 14,
          title: '排班管理',
          name: 'paiban'
        }
      ],
      // 左导航
      leftList: [
        {
          id: 1,
          title: '患者管理',
          name: 'huanzhe'
        },
        {
          id: 2,
          title: '药品管理',
          name: 'yaopin'
        }, {
          id: 3,
          title: '耗材管理',
          name: 'haocai'
        }, {
          id: 4,
          title: '透析管理',
          name: 'touxi'
        }, {
          id: 5,
          title: '医嘱管理',
          name: 'yizhu'
        }, {
          id: 6,
          title: '人员管理',
          name: 'renyuan'
        }, {
          id: 7,
          title: '设备管理',
          name: 'shebei'
        }
      ],
      // 右导航
      rightList: [
        {
          id: 8,
          title: '字典管理',
          name: 'zidian'
        },
        {
          id: 9,
          title: '系统管理',
          name: 'xitong'
        }, {
          id: 10,
          title: '历史数据',
          name: 'lishi'
        }, {
          id: 11,
          title: '医疗文书',
          name: 'yiliao'
        }, {
          id: 12,
          title: '统计分析',
          name: 'tongji'
        }, {
          id: 13,
          title: '质控上报',
          name: 'zhikong'
        }, {
          id: 14,
          title: '排班管理',
          name: 'paiban'
        }
      ],
      // 主体内容
      inList: {
        pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/83A540AA05B444D59B5BDB48D71A7565-6-2.png",
        txt: ['患者信息', '状态查询', '临时透析排班', '长期透析排班', '快捷搜索', '患者档案']
      },
      glID: ''
    }
  },
  components: {
    footerCard,
    titleCard
  },
  created() {

  },
  mounted() {

  },
  methods: {
    clickChange(item) {
      this.glID = item.id
      if (item.name == 'huanzhe') {
        this.inList = {
          pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/83A540AA05B444D59B5BDB48D71A7565-6-2.png",
          txt: ['患者信息', '状态查询', '临时透析排班', '长期透析排班', '快捷搜索', '患者档案']
        }
      } else {
        this.inList = {
          pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/83A540AA05B444D59B5BDB48D71A7565-6-2.png",
          txt: ['患者信息', '状态查询', '临时透析排班', '长期透析排班', '快捷搜索', '患者档案']
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.keshi {
  #liClick {
    color: #fff !important;
    background-color: #0ca6eb !important;
    position: relative;
  }
  #liClick::after {
    @media screen and (max-width: 540px) {
      content: none;
    }
    position: absolute;
    right: -0.2105rem;
    top: 0.3158rem;
    content: '';
    width: 0;
    height: 0;
    border-top: 0.1053rem solid transparent;
    border-left: 0.2105rem solid #0ca6eb;
    border-bottom: 0.1053rem solid transparent;
  }
  #liClick2 {
    color: #fff !important;
    background-color: #0ca6eb !important;
    position: relative;
  }
  #liClick2::after {
    @media screen and (max-width: 540px) {
      content: none;
    }
    position: absolute;
    left: -0.2105rem;
    top: 0.3158rem;
    content: '';
    width: 0;
    height: 0;
    border-top: 0.1053rem solid transparent;
    border-right: 0.2105rem solid #0ca6eb;
    border-bottom: 0.1053rem solid transparent;
  }
  .zhitou {
    .title {
      padding: 1rem 0 1.4316rem 0;
      @media screen and (max-width: 540px) {
        padding: 35px 0 50px 0;
      }
    }
    .content {
      height: 5.2632rem;
      display: flex;
      align-items: center;
      margin-bottom: 2.2632rem;
      @media screen and (max-width: 540px) {
        display: block;
        width: 100%;
        height: 100%;
        padding: 0 37px;
        box-sizing: border-box;
      }
      .left {
        @media screen and (max-width: 540px) {
          width: 100%;
          font-size: 16px;
          line-height: 26px;
          margin: 0;
        }
        width: 5.0526rem;
        margin-right: 1.6842rem;
        margin-left: 3.8947rem;
        color: #272b2d;
        line-height: 0.4rem;
        font-size: 0.2526rem;
      }
      .right {
        width: 7rem;
        @media screen and (max-width: 540px) {
          width: 100%;
          margin-top: 20px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .title2 {
      padding-bottom: 0.6105rem;
    }
  }

  .xinxi {
    .header {
      height: 9.8947rem;
      background-color: #fbfbfb;
      @media screen and (max-width: 540px) {
        height: 100%;
      }
      .header-title {
        padding: 0.9684rem 0 0.6526rem 0;
        font-size: 0.4rem;
        color: #0ca6eb;
        text-align: center;
        font-weight: 600;
        @media screen and (max-width: 540px) {
          font-size: 19px;
        }
      }
      .ios-content {
        display: none;
        @media screen and (max-width: 540px) {
          display: block;
        }
        padding-bottom: 20px;
        .contentmenu {
          padding: 0 14px;
          overflow: hidden;
          li {
            float: left;
            width: 23%;
            margin: 2px;
            height: 42px;
            line-height: 42px;
            background-color: #ffffff;
            border: 1px solid #eaeaea;
            color: #666666;
            font-size: 13px;
            text-align: center;
          }
        }
        .in {
          width: 86%;
          height: 100%;
          margin: 0 auto;
          .pic {
            width: 100%;
            height: 172px;
            margin: 30px 0;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .txt {
            width: 100%;
            overflow: hidden;
            li {
              float: left;
              width: 33%;
              padding: 0.2632rem 0;
              text-align: center;
              color: #666666;
              font-size: 0.2947rem;
              border-bottom: 1px solid #eaeaea;
              border-left: 1px solid #eaeaea;
              @media screen and (max-width: 540px) {
                font-size: 12px;
              }
            }
            li:nth-child(1) {
              border-left: none;
            }
            li:nth-child(4) {
              border-bottom: none;
              border-left: none;
            }
            li:nth-child(5) {
              border-bottom: none;
            }
            li:nth-child(6) {
              border-bottom: none;
            }
          }
        }
      }
      .header-content {
        @media screen and (max-width: 540px) {
          display: none;
        }
        padding: 0 1.6842rem;
        display: flex;
        align-items: center;
        .left {
          width: 2.6737rem;
          li {
            width: 100%;
            height: 0.8842rem;
            text-align: center;
            background-color: #ffffff;
            border: 1px solid #eaeaea;
            color: #666666;
            cursor: pointer;
            line-height: 0.8842rem;
            font-size: 0.2737rem;
            border-radius: 0.0421rem;
            margin-bottom: 0.1684rem;
          }
          li:last-child {
            margin-bottom: 0;
          }
        }
        .in {
          width: 8rem;
          height: 6.3158rem;
          padding: 0 1.7895rem;
          .pic {
            width: 100%;
            height: 4.0211rem;
            margin-bottom: 0.3158rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .txt {
            width: 100%;
            overflow: hidden;

            li {
              float: left;
              width: 33%;
              padding: 0.2632rem 0;
              text-align: center;
              color: #666666;
              font-size: 0.2947rem;
              border-bottom: 1px solid #eaeaea;
              border-left: 1px solid #eaeaea;
            }
            li:nth-child(1) {
              border-left: none;
            }
            li:nth-child(4) {
              border-bottom: none;
              border-left: none;
            }
            li:nth-child(5) {
              border-bottom: none;
            }
            li:nth-child(6) {
              border-bottom: none;
            }
          }
        }
        .right {
          width: 2.6737rem;
          li {
            width: 100%;
            height: 0.8842rem;
            text-align: center;
            color: #666666;
            line-height: 0.8842rem;
            font-size: 0.2737rem;
            cursor: pointer;
            background-color: #ffffff;
            border: 1px solid #eaeaea;
            border-radius: 0.0421rem;
            margin-bottom: 0.1684rem;
          }
          li:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .main {
      height: 9.0526rem;
      background: url('https://yyt-ows.oss-cn-beijing.aliyuncs.com/DC206EBA16744D43B39F444E4875FD8E-6-2.png') no-repeat;
      background-size: 100% 100%;
      @media screen and (max-width: 540px) {
        height: 480px;
        background-size: cover;
      }
      .titletxt {
        text-align: center;
        color: #0ca6eb;
        font-weight: 700;
        font-size: 0.4rem;
        padding: 1.3684rem 0;
        @media screen and (max-width: 540px) {
          font-size: 19px;
        }
      }
      .ios-content {
        display: none;
        @media screen and (max-width: 540px) {
          display: block;
        }
        .content {
          display: flex;
          justify-content: center;
          align-items: center;
          .box {
            width: 8rem;
            height: 86px;
            background: #ffffff;
            border: 1px solid #eaeaea;
            display: flex;
            align-items: center;
            .left {
              width: 26px;
              height: 26px;
              margin: 0 0.3368rem 0 0.3895rem;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .right {
              h2 {
                margin: 0;
                padding-bottom: 10px;
                font-size: 14px;
                color: #000000;
              }
              p {
                font-size: 10px;
                color: #666666;
                line-height: 18px;
              }
            }
          }
          .box:hover {
            h2 {
              color: #0ca6eb;
            }
          }
          .arrow {
            width: 44px;
            height: 21px;
            margin: 0 0.2316rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .bottom {
          height: 52px;
          position: relative;
          .arrow {
            position: absolute;
            width: 21px;
            height: 44px;
            right: 4rem;
            top: 0.1579rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .arrow2 {
            position: absolute;
            width: 21px;
            height: 44px;
            left: 4rem;
            top: 0.1579rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .pc-content {
        @media screen and (max-width: 540px) {
          display: none;
        }
        .content {
          display: flex;
          justify-content: center;
          align-items: center;
          .box {
            width: 4.2737rem;
            height: 1.8105rem;
            background: #ffffff;
            border: 1px solid #eaeaea;
            display: flex;
            align-items: center;
            .left {
              width: 0.6105rem;
              height: 0.6105rem;
              margin: 0 0.3368rem 0 0.3895rem;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .right {
              h2 {
                margin: 0;
                padding-bottom: 0.2947rem;
                font-size: 0.2947rem;
                color: #000000;
              }
              p {
                font-size: 0.2105rem;
                color: #666666;
                line-height: 0.2842rem;
              }
            }
          }
          .box:hover {
            h2 {
              color: #0ca6eb;
            }
          }
          .arrow {
            width: 0.9263rem;
            height: 0.4421rem;
            margin: 0 0.2316rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .bottom {
          height: 1rem;
          position: relative;
          .arrow {
            position: absolute;
            width: 0.4421rem;
            height: 0.7368rem;
            right: 4rem;
            top: 0.1579rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    .footer::-webkit-scrollbar {
      display: none;
    }
    .footer {
      height: 6.2105rem;
      padding: 1.1579rem 0 1.3158rem 0;
      display: flex;
      justify-content: center;
      @media screen and (max-width: 540px) {
        padding: 0 7px;
        height: 100%;
        margin: 18px 0 56px 0;
        overflow: scroll;
        overflow-y: hidden;
        justify-content: left;
      }
      .box {
        width: 5.3684rem;
        margin: 0 0.1579rem;
        cursor: pointer;
        background-color: #fbfbfb;
        @media screen and (max-width: 540px) {
          margin: 0 7px;
          flex-basis: 250px;
          flex-shrink: 0;
        }
        .pic {
          height: 5.1789rem;
          position: relative;
          @media screen and (max-width: 540px) {
            height: 246px;
            width: 100%;
          }
          img {
            width: 100%;
            height: 100%;
          }
          .bg {
            display: none;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            color: #fff;
            font-size: 0.2526rem;
            padding: 0.7895rem;
            line-height: 0.4211rem;
            opacity: 0.8;
            text-align: center;
            padding-top: 2.3158rem;
            box-sizing: border-box;
            background: rgba(0, 0, 0, 0.5);
            @media screen and (max-width: 540px) {
              line-height: 25px;
              font-size: 12px;
            }
          }
        }
        .txt {
          margin-top: -0.0211rem;
          height: 1.0526rem;
          line-height: 1.0526rem;
          color: #666666;
          font-size: 0.2947rem;
          text-align: center;
          @media screen and (max-width: 540px) {
            height: 50px;
            line-height: 50px;
          }
        }
      }
      .box:hover {
        background-color: #0ca6eb;
        .txt {
          color: #fff;
        }
        .pic {
          .bg {
            display: block;
          }
        }
      }
    }
  }
}
</style>
